import { configurationPageClass } from '@modules/configuration/components/configurationLayout';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';
import { useAffiliates } from '../../hooks/useAffiliates';
import { ErrorState } from '../feedback';
import { CardList, Table, Program, Benefits } from '../display';
import { AffiliatesSkeleton } from '../skeletons';
import { EmptyView, EMPTY_VIEW_ICONS } from '@shared/components/ui/EmptyView';
import { useAffiliateCode } from '../../hooks/useAffiliatesTotals';

export const Main = () => {
  const { t } = useTranslation('affiliatesModule');

  // 🎯 Hook con scroll infinito + filtros específicos
  const { affiliates, isLoading, error, refetch, fetchNextPage, hasNextPage, isFetchingNextPage, total } =
    useAffiliates({});

  const { data: codeData } = useAffiliateCode();
  const hasAffiliateCode = !!(codeData?.code || codeData?.name);

  console.log('isLoading', isLoading);

  // Props compartidas para ambas vistas (DRY principle)
  const affiliatesViewProps = useMemo(
    () => ({
      affiliates,
      fetchNextPage,
      hasNextPage,
      isFetchingNextPage,
      total,
    }),
    [affiliates, fetchNextPage, hasNextPage, isFetchingNextPage, total, t],
  );

  // Funcion que decide que vista renderizar (Responsabilidad movida desde Table)
  const renderAffiliates = () => {
    if (isMobile) {
      return <CardList {...affiliatesViewProps} showActions={true} />;
    }

    return <Table {...affiliatesViewProps} />;
  };

  if (error) {
    return <ErrorState error={error} onRetry={refetch} />;
  }

  return (
    <div className={configurationPageClass}>
      {/* Estado de carga */}
      {isLoading ? (
        <AffiliatesSkeleton />
      ) : (
        <>
          {/* Programa de afiliados */}
          <Program />

          {/* Beneficios del programa */}
          <Benefits />
        </>
      )}

      {/* Vista de comisiones - Decision de vista aqui (Mobile vs Desktop) */}
      {/*
      Si tiene codigo de afiliado, se muestra la tabla de comisiones
      */}
      {!isLoading && hasAffiliateCode && affiliates.length > 0 && (
        <>
          <h3 className="text-xl font-semibold mb-4">{t('commissions.historyTitle')}</h3>
          <div className="mb-4">{renderAffiliates()}</div>
        </>
      )}

      {/* Estado vacio - Cuando no hay datos y no esta cargando */}
      {!isLoading && hasAffiliateCode && affiliates.length === 0 && (
        <EmptyView type="noResults" icon={EMPTY_VIEW_ICONS.DEFAULT} className="min-h-0 py-20" />
      )}
    </div>
  );
};
